<template>
    <fa icon="thumbtack" style="color: #e8912d" />
</template>

<script>

export default {
    name: 'thumbtackIcon',
    props: [''],
    emits: [],
    components: {
    },
    data: function() {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },
}
</script>

<style scoped>
</style>


